import $axios from '@/axios-instance.js'

export const customerService = {
  getAll,
  getListData,
  getById,
  create,
  update,
  delete: _delete
}

let cancellationSource

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/customers/get-all`).then(response => {
    return response.data
  })
}

function getListData (filter, page) {
  if (cancellationSource) {
    cancellationSource.cancel('cancel previous request')
  }

  const CancelToken = $axios.CancelToken
  cancellationSource = CancelToken.source()

  return $axios.get(`${process.env.ROOT_API}/customers`, {
    params: Object.assign({ currentPage: page }, filter),
    cancelToken: cancellationSource.token
  })
    .then(response => {
      return response.data
    })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/customers/${id}`).then(response => {
    return response.data
  })
}

function create (customer) {
  return $axios.post(`${process.env.ROOT_API}/customers`, customer).then(response => {
    return response.data
  })
}

function update (customer) {
  return $axios.put(`${process.env.ROOT_API}/customers/${customer.customerId}`, customer).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/customers/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/customer.service.js